import React, { useState, useEffect } from "react";
import { GiHamburgerMenu } from "react-icons/gi";
import { AiOutlineClose } from "react-icons/ai";
import { Link } from "react-scroll";
import {
  FcAbout,
  FcBiotech,
  FcBusinessContact,
  FcHome,
  FcPortraitMode,
  FcReadingEbook,
  FcVideoProjector,
  FcDiploma1,
} from "react-icons/fc";

const navItems = [
  { to: "home", icon: FcHome, label: "Home" },
  { to: "about", icon: FcAbout, label: "About" },
  { to: "education", icon: FcReadingEbook, label: "Education" },
  { to: "work", icon: FcPortraitMode, label: "Work Experience" },
  { to: "techstack", icon: FcBiotech, label: "Tech Stack" },
  { to: "projects", icon: FcVideoProjector, label: "Projects" },
  { to: "certificates", icon: FcDiploma1, label: "Certificates" },
  
  { to: "contact", icon: FcBusinessContact, label: "Contact" },
];

const MobileNav = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleMenuClick = () => setOpen(false);

  return (
    <div className="md:hidden fixed top-0 left-0 right-0 z-50">
      {/* Header Bar */}
      <div
        className={`
          flex items-center justify-between px-5 h-14
          transition-all duration-300
          ${scrolled || open
            ? "bg-[#0f0f1a]/95 backdrop-blur-md border-b border-white/5 shadow-xl"
            : "bg-[#0f0f1a]"
          }
        `}
      >
        <span
          className="font-bold text-lg tracking-wide"
          style={{ fontFamily: "'Syne', sans-serif" }}
        >
          <span className="text-[#f29f67]">Ayush</span>
          <span className="text-white"> Rai</span>
        </span>

        <button
          onClick={() => setOpen(!open)}
          className="p-2 rounded-lg text-white hover:bg-white/10 transition-colors"
          aria-label="Toggle menu"
        >
          {open ? <AiOutlineClose size={22} /> : <GiHamburgerMenu size={22} />}
        </button>
      </div>

      {/* Dropdown Menu */}
      <div
        className={`
          overflow-hidden transition-all duration-300 ease-in-out
          bg-[#0f0f1a]/95 backdrop-blur-md border-b border-white/5
          ${open ? "max-h-screen opacity-100" : "max-h-0 opacity-0"}
        `}
      >
        <nav className="px-4 py-3 space-y-1">
          {navItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              spy={true}
              smooth={true}
              offset={-60}
              duration={400}
              onClick={handleMenuClick}
            >
              <div className="flex items-center gap-3 px-4 py-3 rounded-xl text-gray-300 hover:bg-white/8 hover:text-[#f29f67] transition-all duration-200 cursor-pointer">
                <item.icon className="text-lg" />
                <span className="text-sm font-medium">{item.label}</span>
              </div>
            </Link>
          ))}
        </nav>
      </div>

      {/* Backdrop */}
      {open && (
        <div
          className="fixed inset-0 -z-10 bg-black/40 backdrop-blur-sm"
          onClick={() => setOpen(false)}
        />
      )}
    </div>
  );
};

export default MobileNav;